import { render, staticRenderFns } from "./SemestersAllSelectbox.vue?vue&type=template&id=5a409e4d"
import script from "./SemestersAllSelectbox.vue?vue&type=script&lang=js"
export * from "./SemestersAllSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports